import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Lists from '../components/listManager/Lists';
import AddList from '../components/listManager/AddList';
import { createList, deleteList, setCurrentList, clearBannerMessage } from '../actions/actions';
import { IS_FILTERING } from '../actions/constants';
import './styles/ListManager.scss';

export class ListManagerClass extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showingInput: false,
		}
	}

	onToggleClick = () => {
		this.setState({ showingInput: !this.state.showingInput });
		this.props.clearBanner();
	}

	hideInput = () => {
		this.setState({ showingInput: false });
	}

	createList = (name, list) => {
		this.props.createList(name, list);
		this.setState({ showingInput: false });
	}

	select = id => {
		this.props.setCurrentList(id);
	}

	render() {
		const { i18n, tree, allLists, selectedList } = this.props; // eslint-disable-line no-unused-vars

		return (
			<div id='list_manager'>
				<div className='heading'>
					<span className='title'>{i18n.t('DISTRIBUTION_LISTS')}</span>
					<span className='add' onClick={this.onToggleClick}></span>
				</div>
				{this.state.showingInput
					? <AddList {...this.props} createList={this.createList} hideInput={this.hideInput} />
					: ''}
				<Lists {...this.props} select={this.select} />
			</div>
		);
	}
}
const mapDispatchToProps = dispatch => ({
	createList: (name, list) => {
		dispatch(createList(name, list));
		dispatch({type: IS_FILTERING, payload: false});
		dispatch(clearBannerMessage());
	},
	deleteList: id => { dispatch(deleteList(id)) },
	setCurrentList: id => {
		dispatch(setCurrentList(id, false))
		dispatch({type: IS_FILTERING, payload: false});
		dispatch(clearBannerMessage());
	},
	clearBanner: () => {
		dispatch(clearBannerMessage());
	},
});

ListManagerClass.propTypes = {
	createList: PropTypes.func.isRequired,
	deleteList: PropTypes.func.isRequired,
	setCurrentList: PropTypes.func.isRequired,
	clearBanner: PropTypes.func.isRequired,
	allLists: PropTypes.array.isRequired,
	i18n: PropTypes.shape({}).isRequired,
	tree: PropTypes.shape({}).isRequired,
	selectedList: PropTypes.shape({}).isRequired,
};

const mapStateToProps = state => ({
	allLists: state.allLists,
	selectedList: state.selectedList,
});

const ListManager = connect(
	mapStateToProps,
	mapDispatchToProps
)(ListManagerClass);

export default withTranslation()(ListManager);
